export class NoSupportedLocalesException extends Error {
    public name: string;

    constructor() {
        super('No supported languages has been provided during localization module initialization');
        this.name = 'NoSupportedLocalesException';
    }
}
